import React from 'react'
import Spinner from './Spinner'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'

type Props = {}

const TutorLoadingScreen = (props: Props) => {
  const isStudentPresentOnLessonScreen = useSelector(
    (state: RootReducer) => state.tutorChannelReducer.isStudentPresentOnLessonScreen
  )
  const connectionState = useSelector((state: RootReducer) => state.janusReducer.connectionState)
  if (connectionState === 'connected') {
    return <></>
  }
  return (
    <div className="fixed w-screen h-screen bg-[rgba(0,0,0,0.45)] top-0 lef-0">
      <div className="fixed w-full h-full flex items-center justify-center">
        <div className="mb-28 text-22">{isStudentPresentOnLessonScreen ? 'Connecting' : 'Waiting for Student'}</div>
      </div>
      <Spinner />
    </div>
  )
}

export default TutorLoadingScreen
